<template>
  <div class="accordion">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style></style>
